import {makeStyles} from '@material-ui/core/styles';


const useStyles = makeStyles((theme) => ({
    title:{
        marginTop:'25px',
        textAlign:'center',
        fontFamily: theme.font.balsamiq + " !important",
        [theme.breakpoints.down("sm")]:{
            marginTop: theme.size.heightHeaderPhone,
        },
    },

    titlePart:{
        fontFamily: theme.font.balsamiq + " !important",
    },
}));

export default useStyles;